<mat-form-field class="w-full cursor-pointer" subscriptSizing="dynamic" (click)="showSelectClientDialog()">
  <mat-label class="flex justify-between">
    {{label}}  
    <small *ngIf="nameControl.value?.length > 0" (click)="edit(); $event.stopPropagation()" class="cursor-pointer mx-2 text-sm text-primary">edytuj</small>
  </mat-label>
  <mat-icon matPrefix *ngIf="nameControl.value?.length == 0" [svgIcon]="'tabler_outline:user-search'"></mat-icon>
  <mat-icon matPrefix *ngIf="nameControl.value?.length > 0" [svgIcon]="'tabler_outline:user-check'"></mat-icon>
  <input type="text" class="cursor-pointer" [formControl]="nameControl" readonly matInput />
  <mat-icon matSuffix *ngIf="nameControl.value?.length > 0" [svgIcon]="'heroicons_solid:chevron-down'"></mat-icon>
</mat-form-field>